module.exports = __webpack_public_path__ + "img/LUB00379.52497431.png";